export default __webpack_public_path__ + "static/media/village-killed.7b90ab76.mp3";